import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-nt-btn',
  templateUrl: './nt-btn.component.html',
  styleUrls: ['./nt-btn.component.scss']
})
export class NtBtnComponent implements OnInit {
    @Input() color = '';
    @Input() disabled = false;
    @Input() icon = '';
    @Input() text = '';
    @Input() class = '';
    @Input() router = [];

    @Output() clicked = new EventEmitter();

    constructor() { }

    ngOnInit(): void {
    }

    executeClick(){
        this.clicked.emit();
    }

}
